import parse from 'html-react-parser';
import { getText } from '../../utils/languageUtils';

const ConsentForm = ({
    consentFormData,
    dataConsent,
    setDataConsent,
    submitConsentForm,
    language,
    translationData
}) => {
    const translations = translationData?.baseline || {};
    return (
        <div className="container-fluid px-0">
            <div className="row justify-content-center">
                <div className="col-xxl-5 col-xl-7 col-lg-8 col-md-12">
                    {consentFormData && <section className="my-3">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="sectionsBox">
                                        <p className="mb-0 text-center">{getText(translations.student_consent, language)}</p>
                                    </div>
                                </div>
                            </div>
                            <form>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="mb-0 text-center p-1 mt-2 mb-2">{parse(getText(consentFormData?.description, language))}</div>
                                        <div className="form-check">
                                            <input className="form-check-input me-2" type="checkbox"
                                                required
                                                defaultChecked={dataConsent}
                                                onChange={e => setDataConsent(!(dataConsent))}
                                            />
                                            <label className="form-check-label" htmlFor="flexCheckDefault">
                                                {getText(consentFormData?.short_condition, language)}
                                            </label>
                                        </div>

                                    </div>

                                </div>
                                <div className="col-12 d-flex justify-content-center">
                                    <button onClick={() => { submitConsentForm() }} type="button" className="btn btn-danger  custom-button-next">
                                       {getText(translations.submit, language)}
                                    </button>
                                </div>
                            </form>



                        </div>
                    </section>
                    }
                </div>
            </div>

        </div>
    )
}

export default ConsentForm